document.addEventListener("DOMContentLoaded", function () {

    //Lang switcher
    $('#switcher').click(function() {
        $(this).toggleClass('active');
        $('#switcher ul').toggleClass('open');
    });

    //Slick slider
    $(document).ready(function(){
        $('.carousel-header').slick({
            autoplay: true,
            autoplaySpeed: 5000,
            adaptiveHeight: true
        });
    });
       
    // Box colapsable

    var el = document.getElementsByClassName('colapsable');
    for (var i = 0; i < el.length; i++) {
        el[i].on = false;
        el[i].onclick = function () {
            if (this.on === false) {
                this.getElementsByClassName('colapsable-content')[0].style.display = "block";
                this.getElementsByClassName('arrow')[0].classList.add('rotated');
                this.on = true;

            } else {
                this.getElementsByClassName('colapsable-content')[0].style.display = "none";
                this.getElementsByClassName('arrow')[0].classList.remove('rotated');
                this.on = false;
            }
        }
    }

    //Handle centering of promos

    var promos = $('.promos-cards .card');
    if(promos.length < 4){
        $('.promos-cards .cards').css('justify-content','space-around');
    }

});


